import React from 'react';
import { Box } from '@mui/material';
import alegionLogo from '../assets/images/alegion-logo.png';
import { containImageSx } from '../theme/designTokens';

const BrandLogo = ({
  src = alegionLogo,
  alt = 'ALEgION® — Engineering Resilience',
  imageSx = {},
  component = 'div',
  ...wrapperProps
}) => (
  <Box
    component={component}
    {...wrapperProps}
    sx={{
      display: 'inline-flex',
      lineHeight: 0,
      flexShrink: 0,
      ...wrapperProps.sx,
    }}
  >
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        ...containImageSx,
        display: 'block',
        ...imageSx,
      }}
    />
  </Box>
);

export default BrandLogo;
